import React from "react";

import MovieList from "../../components/movie/MovieList";
import Banner from "../../components/Banner";
import NavBar from "../../components/Navbar";
import Section from "../../components/Section";

function Movies() {
    
    return (
        <>
            <NavBar />
            <Banner />

            <Section title="Trending Movies"  >
                <MovieList />
            </Section>
        </>
    );
}

export default Movies;
